export const disclaimerFormatter = (value: any) => value || <i>optional - not set</i>;

export const tagFormatter = (value: any) => value || <i>optional - not set</i>;
